module.exports = "\n<div id=\"{{game._id ? game._id:game.id}}-middlesmall\" style=\"margin-bottom: 5px;\" _v-bdb12b9c=\"\">\n  <div id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:60px;\" :class=\"classboard\" _v-bdb12b9c=\"\">\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-bdb12b9c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/game/boardVisorSmall.vue
// module id = 525
// module chunks = 10